import { Category, CategoryRegionOverride } from '@/services/api/contracts/catalog/types';

export const resolveDeployOverrideRateCardId = (category?: Category | null, regionId?: string | null): string | undefined => {
  if (!category) return undefined;
  
  if (regionId && category.regionOverrides) {
    const override = category.regionOverrides.find((ro: CategoryRegionOverride) => ro.regionId === regionId);
    if (override && override.deployOverrideRateCardId) {
      return override.deployOverrideRateCardId;
    }
  }
  
  return category.logisticsConfig?.deploy?.overrideRateCardId;
};

export const resolveDeployProcessingRateCardId = (category?: Category | null, regionId?: string | null): string | undefined => {
  if (!category) return undefined;
  
  if (regionId && category.regionOverrides) {
    const override = category.regionOverrides.find((ro: CategoryRegionOverride) => ro.regionId === regionId);
    if (override && override.deployItemProcessingRateCardId) {
      return override.deployItemProcessingRateCardId;
    }
  }
  
  return category.logisticsConfig?.deploy?.itemProcessingRateCardId;
};

export const resolveReturnOverrideRateCardId = (category?: Category | null, regionId?: string | null): string | undefined => {
  if (!category) return undefined;
  
  if (regionId && category.regionOverrides) {
    const override = category.regionOverrides.find((ro: CategoryRegionOverride) => ro.regionId === regionId);
    if (override && override.returnOverrideRateCardId) {
      return override.returnOverrideRateCardId;
    }
  }
  
  return category.logisticsConfig?.return?.overrideRateCardId;
};

export const resolveReturnProcessingRateCardId = (category?: Category | null, regionId?: string | null): string | undefined => {
  if (!category) return undefined;
  
  if (regionId && category.regionOverrides) {
    const override = category.regionOverrides.find((ro: CategoryRegionOverride) => ro.regionId === regionId);
    if (override && override.returnItemProcessingRateCardId) {
      return override.returnItemProcessingRateCardId;
    }
  }
  
  return category.logisticsConfig?.return?.itemProcessingRateCardId;
};


